export default __webpack_public_path__ + "static/media/adidas.2d2e1277.png";